import React, { FC, ReactNode } from 'react'
import styles from 'styles/components/flex.module.scss'
import classNames from 'classnames'

type Props = {
  alignItems?: 'start' | 'end' | 'center' | 'baseline'
  dataCy?: string
  flex?: 1
  gap?: 1 | 2 | 3 | 4 // 4px * gap
  justifyContent: 'start' | 'end' | 'between' | 'center' | 'around'
  itemNum?: string
  wrap?: 'wrap' | 'nowrap'
  children: ReactNode
}

const FlexRow: FC<Props> = (props) => {
  const { alignItems, children, dataCy, flex, gap, justifyContent, itemNum, wrap } = props

  return (
    <div
      className={classNames({
        [styles[`flex__row_align_${alignItems}`]]: alignItems,
        [styles[`flex__row_${justifyContent}`]]: justifyContent,
        [styles[`flex__row__item_${itemNum}`]]: itemNum,
        [styles[`flex__row_${wrap}`]]: wrap,
        [styles[`flex__row_flex_${flex}`]]: flex,
        [styles[`flex__row_gap_${gap}`]]: gap,
      })}
      data-cy={dataCy}
    >
      {children}
    </div>
  )
}

export default FlexRow
